export const SET_ELE_ADDRESS = 'SET_ELE_ADDRESS'
export const SET_ELE_EDIT_ADDRESS = 'SET_ELE_EDIT_ADDRESS'
export const SET_ELE_SHOP = 'SET_ELE_SHOP'
export const SET_ELE_CART = 'SET_ELE_CART'
export const ELE_LOCAL_ADD = 'ELE_LOCAL_ADD'
export const ELE_CITY = 'ELE_CITY'
export const ELE_CITY_LIST = 'ELE_CITY_LIST'
export const ELE_LOCAL_CITY = 'ELE_LOCAL_CITY'
export const ELE_KEYWORD = 'ELE_KEYWORD'
export const IS_XINGBAKE = 'IS_XINGBAKE'
export const ELE_REFRESH = 'ELE_REFRESH'
export const EVENT = 'EVENT'
export const SHOP_DETAIL = 'SHOP_DETAIL'